import { CARD_DATA_REFRESH_INTERVAL_MS } from '@shared-core/config/polling'
import { selectedIsAuthorized } from '@shared-core/features/auth'
import { fetchCardTemplates, selectedCardTemplates } from '@shared-core/features/backend'
import { useSharedPoller } from '@shared-core/hooks/use-shared-poller'
import { useAppDispatch, useAppSelector } from '@shared-core/store'

// Шаблоны обновляются по validTime и доступны без авторизации. Опрос общий для всех потребителей хука;
// смена статуса авторизации перезапускает цикл через новый ключ, как и раньше перезапускался эффект.
export function useCardTemplates() {
  const dispatch = useAppDispatch()
  const isAuthorized = useAppSelector(selectedIsAuthorized)
  const cardTemplates = useAppSelector(selectedCardTemplates)

  useSharedPoller({
    key: isAuthorized ? 'card-templates:auth' : 'card-templates:guest',
    enabled: true,
    intervalMs: CARD_DATA_REFRESH_INTERVAL_MS,
    run: async () => {
      const templates = await dispatch(fetchCardTemplates()).unwrap()

      return templates?.length ? Math.min(...templates.map((template) => template.rates.validTime)) * 1000 : undefined
    },
  })

  return cardTemplates
}
